// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import 'reset-css'
//  reset.css
import './assets/css/reset.css'
//  rem.js
import './assets/js/rem'
Vue.use(ElementUI);

Vue.config.productionTip = false
/* 引入公共js*/
import common from '@/assets/js/common.js'
Vue.prototype.common=common;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js